import React, { type FC } from 'react';
import clsx from 'clsx';
import { Modal } from '@is24at/react-modals';
import { FlexBox, Text } from '@is24at/react-ui-core';
import {
  Facebook,
  Share,
  Twitter,
  WhatsApp,
} from '@is24at/react-ui-core/Icons';
import { ShareAction } from './ShareAction';
import styles from './Share.scss';

interface Props {
  companyName: string;
  onClose: () => void;
}

const shareTo = (shareAction: ShareAction, companyName?: string) => {
  switch (shareAction) {
    case ShareAction.FACEBOOK:
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`,
        '_blank',
      );
      break;
    case ShareAction.WHATSAPP:
      window.open(
        `whatsapp://send?text=${companyName} ${window.location.href}`,
        '_blank',
      );
      break;
    case ShareAction.TWITTER:
      window.open(
        `https://twitter.com/intent/tweet?text=${window.location.href}`,
        '_blank',
      );
      break;
    default:
      break;
  }
};

export const ShareModal: FC<Props> = ({ companyName, onClose }) => (
  <Modal
    onClose={onClose}
    showCloseButton
    modalId="share-modal"
    customStyles={{
      content: styles.modal__content,
    }}
    title={
      <FlexBox spacing={8}>
        <Share size={25} className={styles.icon} />
        <Text tag="h5" className={styles.title__text}>
          Teilen
        </Text>
      </FlexBox>
    }
  >
    <div className={clsx('mt-24', styles.container)}>
      <button
        type="button"
        className={styles.button}
        onClick={() => shareTo(ShareAction.FACEBOOK)}
      >
        <Facebook size={32} className={styles.icon} />
        <Text className={styles['button-text']}>Facebook</Text>
      </button>
      <button
        type="button"
        className={styles.button}
        onClick={() => shareTo(ShareAction.TWITTER)}
      >
        <Twitter size={32} className={styles.icon} />
        <Text className={styles['button-text']}>Twitter</Text>
      </button>
      <button
        type="button"
        className={styles.button}
        onClick={() => shareTo(ShareAction.WHATSAPP, companyName)}
      >
        <WhatsApp size={32} className={styles.icon} />
        <Text className={styles['button-text']}>WhatsApp</Text>
      </button>
    </div>
  </Modal>
);
